// extracted by mini-css-extract-plugin
export default {"root":"TaskActions_root__eOgY1","actions":"TaskActions_actions__MLfZd"};